// src/cursor.js
export const initCustomCursor = () => {
  // Only run on desktop
  if (window.innerWidth < 1024 || 'ontouchstart' in window) return;

  let cursorDot = null;
  let cursorChase = null;
  let mouseX = 0;
  let mouseY = 0;
  let chaseX = 0;
  let chaseY = 0;

  // Create cursor elements
  const createCursors = () => {
    // Main dot
    cursorDot = document.createElement('div');
    cursorDot.style.cssText = `
      position: fixed;
      width: 8px;
      height: 8px;
      background: white;
      border-radius: 50%;
      pointer-events: none;
      z-index: 99999;
      mix-blend-mode: difference;
      transition: transform 0.1s ease;
    `;
    document.body.appendChild(cursorDot);

    // Chase cursor
    cursorChase = document.createElement('div');
    cursorChase.style.cssText = `
      position: fixed;
      width: 32px;
      height: 32px;
      border: 2px solid rgba(168, 85, 247, 0.5);
      background: rgba(168, 85, 247, 0.1);
      border-radius: 50%;
      pointer-events: none;
      z-index: 99998;
      backdrop-filter: blur(4px);
      box-shadow: 0 0 20px rgba(168, 85, 247, 0.3), 0 0 40px rgba(168, 85, 247, 0.1);
      transition: width 0.2s ease, height 0.2s ease, border-color 0.2s ease;
    `;
    document.body.appendChild(cursorChase);
  };

  // Track mouse position
  const onMouseMove = (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    
    if (cursorDot) {
      cursorDot.style.left = mouseX + 'px';
      cursorDot.style.top = mouseY + 'px';
      cursorDot.style.transform = 'translate(-50%, -50%)';
    }
  };

  // Animate chase cursor
  const animateChase = () => {
    const speed = 0.15; // Adjust for chase speed (lower = slower)
    
    chaseX += (mouseX - chaseX) * speed;
    chaseY += (mouseY - chaseY) * speed;
    
    if (cursorChase) {
      cursorChase.style.left = chaseX + 'px';
      cursorChase.style.top = chaseY + 'px';
      cursorChase.style.transform = 'translate(-50%, -50%)';
    }
    
    requestAnimationFrame(animateChase);
  };

  // Handle hover states
  const onMouseOver = (e) => {
    const target = e.target;
    if (
      target.tagName === 'A' ||
      target.tagName === 'BUTTON' ||
      target.getAttribute('role') === 'button' ||
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA'
    ) {
      if (cursorChase) {
        cursorChase.style.width = '48px';
        cursorChase.style.height = '48px';
        cursorChase.style.borderColor = 'rgba(168, 85, 247, 0.8)';
      }
    }
  };

  const onMouseOut = () => {
    if (cursorChase) {
      cursorChase.style.width = '32px';
      cursorChase.style.height = '32px';
      cursorChase.style.borderColor = 'rgba(168, 85, 247, 0.5)';
    }
  };

  // Initialize
  createCursors();
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseover', onMouseOver);
  document.addEventListener('mouseout', onMouseOut);
  animateChase();

  // Cleanup function
  return () => {
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseover', onMouseOver);
    document.removeEventListener('mouseout', onMouseOut);
    if (cursorDot) cursorDot.remove();
    if (cursorChase) cursorChase.remove();
  };
};